/**
 * Check if setting option is disabled or enabled
 *
 * Properties must be set explicitly to a boolean of false to be disabled. If
 * the config key is undefined or true then the setting option is enabled.
 *
 * @param {Object} config //Field settings config object
 * @param {String} key //Property you're checking on the config
 * @returns {Boolean}
 */
export const isSettingHidden = (config, key) => {
  return config && typeof config[key] === 'boolean' && !config[key];
};

/**
 * Check if style setting option is disabled or enabled
 *
 * Properties must be set explicitly to a boolean of false to be disabled. If
 * the config key is undefined or true then the setting option is enabled.
 *
 * 1. config.styles === false then all styles are disabled
 * 2. config.style.key === false then style option is disabled
 *
 * @param {Object} config //Field settings config object
 * @param {String} key //Property you're checking on the config
 * @returns {Boolean}
 */
export const isStyleSettingHidden = (config, key) => {

  if (!config) return false;

  else if (typeof config.styles === 'boolean' && !config.styles) return true;

  else return config.styles && typeof config.styles[key] === 'boolean' && !config.styles[key];

};
